export enum NotificationTypeEnum {
  'order' = 'order',
  'offer-purchase' = 'offer-purchase',
}
